import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { CreateTaskDialogModule } from "@app/components/create-task-dialog/create-task-dialog.module";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { ClientProjectEntryComponent } from "./client-project-entry/client-project-entry.component";
import { ClientProjectPickerDialogComponent } from "./client-project-picker-dialog.component";

@NgModule({
	declarations: [ClientProjectPickerDialogComponent, ClientProjectEntryComponent],
	imports: [
		CommonModule,
		MaterialModule,

		FormsModule,
		ReactiveFormsModule,
		CustomDirectivesModule,
		TranslateModule,
		RouterModule,
		ScrollingModule,
		CreateTaskDialogModule,
	],
	exports: [ClientProjectPickerDialogComponent],
})
export class ClientProjectPickerDialogModule {}
